import { render, staticRenderFns } from "./PromoBadges.vue?vue&type=template&id=029cb969&scoped=true"
import script from "./PromoBadges.vue?vue&type=script&lang=js"
export * from "./PromoBadges.vue?vue&type=script&lang=js"
import style0 from "./PromoBadges.vue?vue&type=style&index=0&id=029cb969&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029cb969",
  null
  
)

export default component.exports